import React, { useState } from 'react';
import { Form } from 'react-bootstrap';
import Inputs from 'components/inputs/inputs';
import ChangeStatusButtons from './changeStatusButtons';
import employeeService from 'services/employeeService';
import useAsyncEffect from 'use-async-effect';
import moment from 'moment';

const styles = {
  topNav: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '0.5rem',
    marginTop: '0.5rem',
  },
  deleteButton: {
    width: '100%',
  },
  backButton: {
    marginRight: '0.5rem',
    flex: '1',
  },
  editButton: {
    marginLeft: '0.5rem',
    flex: '1',
  },
  formLabel: {
    fontSize: '0.75rem',
    fontWeight: 770,
  },
  formValue: { marginTop: '-1rem' },
  formGroup: {
    marginBottom: '0.1rem',
  },
  statusHolder: {
    display: 'grid',
    gridTemplateColumns: '6.5rem 1fr',
  },
};
const statusToLabel = {
  punchIn: 'Punched In',
  punchOut: 'Punched Out',
  startBreak: 'Started Break',
};

export default function EmployeeDetails(props) {
  const id = props.match.params.id;

  const [employeeStatus, setEmployeeStatus] = useState('punchIn');

  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [employmentType, setEmploymentType] = useState('');
  const [employeeNumber, setEmployeeNumber] = useState('');
  const [gender, setGender] = useState('m');
  const [geoState, setGeoState] = useState('');
  const [step, setStep] = useState(1);
  const [basePay, setBasePay] = useState('');
  const [maritalStatus, setMaritalStatus] = useState('single');
  const [hiredDate, setHiredDate] = useState('');
  const [leftDate, setLeftDate] = useState('');
  const [cardNumber, setCardNumber] = useState('');
  const [ssn, setSSN] = useState('');
  const [phone, setPhone] = useState('');
  const [city, setCity] = useState('');
  const [address1, setAddress1] = useState('');
  const [address2, setAddress2] = useState('');
  const [isLoaded, setIsLoaded] = useState(false);
  const [hierarchyId, setHierarchyId] = useState();
  const [email, setEmail] = useState('');
  const [payPeriod, setPayPeriod] = useState('');

  useAsyncEffect(async () => {
    const employeeData = await employeeService.getEmployeeDetails(id);
    setFirstName(employeeData.firstName);
    setLastName(employeeData.lastName);
    setEmploymentType(employeeData.employmentType);
    setEmployeeNumber(employeeData.employeeNumber);
    setGender(employeeData.gender);
    setPhone(employeeData.phone);
    setGeoState(employeeData.state);
    setCity(employeeData.city);
    setAddress1(employeeData.address1);
    setAddress2(employeeData.address2);
    setMaritalStatus(employeeData.maritalStatus);
    setBasePay(employeeData.basePay);
    setCardNumber(employeeData.cardNumber);
    setHiredDate(employeeData.hiredDate);
    setLeftDate(employeeData.leftDate);
    setHierarchyId(employeeData.hierarchyId);
    setEmail('TODOOOOOOOO');
    setPayPeriod('TODOOOOO');
  }, []);

  return (
    <>
      <div style={styles.topNav}>
        <Inputs.Button
          variant='app'
          onClick={() => {
            props.history.push('/EmployeeList');
          }}
          style={styles.backButton}
          label='Back'
        />

        <Inputs.Button
          variant='app'
          onClick={() => {
            props.history.push(`/EmployeeList/${id}/edit`);
          }}
          style={styles.editButton}
          label='Edit'
        />
      </div>
      <div>
        <Form.Group style={styles.formGroup}>
          <Form.Label style={styles.formLabel}>Status:</Form.Label>
          <div style={styles.statusHolder}>
            <Inputs.Text style={styles.formValue} readOnly value={statusToLabel[employeeStatus]} />
            <ChangeStatusButtons status={employeeStatus} onChange={setEmployeeStatus} />
          </div>
        </Form.Group>
        <Form.Group style={styles.formGroup}>
          <Form.Label style={styles.formLabel}>Name:</Form.Label>
          <Inputs.Text style={styles.formValue} readOnly value={`${firstName} ${lastName}`} />
        </Form.Group>
        <Form.Group style={styles.formGroup}>
          <Form.Label style={styles.formLabel}>Email:</Form.Label>
          <Inputs.Text style={styles.formValue} readOnly value={email} />
        </Form.Group>
        <Form.Group style={styles.formGroup}>
          <Form.Label style={styles.formLabel}>Employee Number:</Form.Label>
          <Inputs.Text style={styles.formValue} readOnly value={employeeNumber} />
        </Form.Group>
        <Form.Group style={styles.formGroup}>
          <Form.Label style={styles.formLabel}>Employment Type:</Form.Label>
          <Inputs.Text style={styles.formValue} readOnly value={formatEmploymentType(employmentType)} />
        </Form.Group>
        <Form.Group style={styles.formGroup}>
          <Form.Label style={styles.formLabel}>Card Number:</Form.Label>
          <Inputs.Text style={styles.formValue} readOnly value={cardNumber} />
        </Form.Group>
        <Form.Group style={styles.formGroup}>
          <Form.Label style={styles.formLabel}>Date Hired:</Form.Label>
          <Inputs.Text style={styles.formValue} readOnly value={formatDate(hiredDate)} />
        </Form.Group>
        <Form.Group style={styles.formGroup}>
          <Form.Label style={styles.formLabel}>Date Left:</Form.Label>
          <Inputs.Text style={styles.formValue} readOnly value={formatDate(leftDate)} />
        </Form.Group>
        <Form.Group style={styles.formGroup}>
          <Form.Label style={styles.formLabel}>Gender:</Form.Label>
          <Inputs.Text style={styles.formValue} readOnly value={formatGender(gender)} />
        </Form.Group>
        <Form.Group style={styles.formGroup}>
          <Form.Label style={styles.formLabel}>Marital Status:</Form.Label>
          <Inputs.Text style={styles.formValue} readOnly value={maritalStatus} />
        </Form.Group>
        <Form.Group style={styles.formGroup}>
          <Form.Label style={styles.formLabel}>Phone:</Form.Label>
          <Inputs.Text style={styles.formValue} readOnly value={formatPhoneNumber(phone)} />
        </Form.Group>
        <Form.Group style={styles.formGroup}>
          <Form.Label style={styles.formLabel}>Address:</Form.Label>
          <Inputs.Text style={styles.formValue} readOnly value={`${address1} ${address2}`} />
        </Form.Group>
        <Form.Group style={styles.formGroup}>
          <Form.Label style={styles.formLabel}>Base Pay:</Form.Label>
          <Inputs.Text style={styles.formValue} readOnly value={`$${basePay}`} />
        </Form.Group>
        <Form.Group style={styles.formGroup}>
          <Form.Label style={styles.formLabel}>Pay period:</Form.Label>
          <Inputs.Text style={styles.formValue} readOnly value={payPeriod} />
        </Form.Group>
      </div>
      <div>
        <Inputs.Button
          variant='danger'
          style={styles.deleteButton}
          onClick={() => {
            props.history.push('/EmployeeList');
          }}
          label='Deactivate'
        />
      </div>
    </>
  );
}

function formatPhoneNumber(phoneNumberString) {
  if (phoneNumberString === '') return '';
  var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
  var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return '(' + match[1] + ') ' + match[2] + '-' + match[3];
  }
  return null;
}

function formatDate(date) {
  if (date === '') return '';
  return moment(date).format('L');
}

function formatGender(gender) {
  if (gender === 'm') return 'Male';
  if (gender === 'f') return 'Female';
}

function formatEmploymentType(type) {
  if (type === 'r') {
    return 'Regular';
  }
  if (type === 'm') {
    return 'Manager';
  }
  return '';
}
